// extracted by mini-css-extract-plugin
export var button = "_fc-4";
export var hasDarkBackground = "_fc-7";
export var hasLightBackground = "_fc-6";
export var iconWrapper = "_fc-0";
export var large = "_fc-2";
export var medium = "_fc-1";
export var small = "_fc-5";
export var xsmall = "_fc-3";